<!-- Heading Title -->
<div class="card" [style]="style">
  <p class="card-desc">{{ description }}</p>
  <div *ngIf="isTestimonial" class="testimonial-content">
    <div class="testimonial-content-rating">
      <ng-container *ngIf="rating === 4; else fiveStar">
        <img [src]="sharedService.imagesUrl +  '4-star.png'" />
      </ng-container>
      <ng-template #fiveStar>
        <img [src]="sharedService.imagesUrl + '5-star.png'" />
      </ng-template>
    </div>
    <div class="testimonial-content-user">
      <div class="testimonial-content-user-img">
        <img [src]="userimg" width="48" />
      </div>
      <div class="testimonial-content-user-name">{{username}}</div>
    </div>
    <div class="testimonial-content-date">{{date}}</div>
  </div>
</div>
<!-- Heading Title END -->
